import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocalizedText } from 'src/app/admin/kiosk-configuration/model/localized_text';
import { IUserServiceDataGrid } from 'src/app/admin/user/shared/models/user-service-data-grid';
import { AppInitService } from 'src/app/app-init.service';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';
import { Language } from 'src/app/master/models/language';
import { SerivceType } from 'src/app/master/models/serviceType';
import { ToastService } from 'src/app/shared/services/toast.service';
import { ILocationsServiceGridData } from '../models/locations-service-grid-data';
import { LocationsServiceGridParams } from '../models/locations-Service-grid-params';
import { ProductCategoryCodesAndNames } from '../models/ProductCategoryCodesAndName';
import { ProductServicesResponseModel } from '../models/productServicesResponseModel';
import { ServiceAppointmentSetting } from '../models/service-appointment-setting';
import { ServiceBasicSetting } from '../models/service-basic-setting';
import { IServiceGrid } from '../models/service-grid';
import { ServiceGridParams } from '../models/service-grid-params';
import { ServiceLobbyAppSetting, ServiceLobbySetting } from '../models/service-lobby-setting';
import { ServiceOptInSetting } from '../models/service-optIn-setting';
import { ServiceSortOrder } from '../models/service-sort-order';
import { ServiceSortOrderModel } from '../models/service-sort-order-model';
import { IServicesGrid } from '../models/services-grid';

import { ServiceEmployeeSettingsParam } from '../models/service-employee-settings-param';
import { ServiceEmployeeSetting } from '../models/service-employee-setting';
import { ServiceAppointmentSettingsParam } from '../models/service-appointment-settings-param';
import { IServiceAppointmentSettingGridData } from '../models/service-appointment-setting-grid-data';
import { ServiceLobbyGridParam } from '../models/service-lobby-grid-param';
import { IServiceLobbySettingsGridData } from '../models/service-lobby-setting-grid-data';
// import { UserServiceForLocationGrid } from '../models/user-service-for-location-grid';
import { LocationDropDownModel } from 'src/app/shared/models/locations-drop-down-list.model';
import { SignedUserLocations } from '../models/signed-user-locations';
import { CheckListGridParam } from '../models/checklist-grid-params';
import { Service } from '../models/service';
import { Store } from "@ngrx/store";
import { getLoggedInUserInfo } from "src/app/state";
import { State } from "src/app/state/app.state";


@Injectable({
  providedIn: 'root'
})
export class ProductServicesService {

  public baseApiUrl: string = '';
  public lookUpsController: string = '';
  public endpoint = 'services';
  servicesUri: string = '';
  public serviceDataforEdit: Service = <Service>{};
  public appointmentSettingData: any;
  public lobbuSettingData: IServiceLobbySettingsGridData = {} as IServiceLobbySettingsGridData;
  private pageMode: string = '';
  public buttonType: string = '';
  public isInvUpdated: boolean = false;
  private languagesSubject = new BehaviorSubject(new Array<Language>());
  private categoriesSubject = new BehaviorSubject(new Array<any>());
  private meetingPreferencesSubject = new BehaviorSubject('');
  private serviceTypeSubject = new BehaviorSubject(new Array<SerivceType>());
  private locationHierachySubject = new BehaviorSubject(new SignedUserLocations());
  private preferredLanguageId : number = 1;

  private serviceSubject = new BehaviorSubject({} as Service);
  sericeData = this.serviceSubject.asObservable();

  private serviceTypes: SerivceType[] = [];
  private appConfig!: AppConfigurations;

  categoryDropDownData = this.categoriesSubject.asObservable();
  languageDropDownData = this.languagesSubject.asObservable();
  serviceTypeDropDownData = this.serviceTypeSubject.asObservable();
  meetingPreferencData = this.meetingPreferencesSubject.asObservable();
  locationHierachyData = this.locationHierachySubject.asObservable();
  public parentLocationIds: any[] = [];
  public loggedInLocationId: number = -1
  public globalDisplayOrderData = null;
  public catgoryDisplyOrderData = null;
  public isGlobalDisplayOrderChanged: boolean = false;
  public isCategoryDisplayOrderChanged: boolean = false;
  public selectedCategoryId: number = 0;


  locations: LocationDropDownModel[] = [
    {
      locationName: "All",
      locationId: -1,
      hasChild: true,
      items: [],
      locationTypeId: 0
    }
  ]
  public locationId = -1;

  private subject = new Subject<any>();
  private appSubject = new Subject<any>();
  sendGridDataEvent() {
    this.subject.next(undefined);
  }
  getGridDataEvent(): Observable<any> {
    return this.subject.asObservable();
  }

  sendAppGridDataEvent() {
    this.appSubject.next(undefined);
  }
  getAppGridDataEvent(): Observable<any> {
    return this.appSubject.asObservable();
  }
  sendpsBasicSetting() {
    this.subject.next(undefined);
  }
  getpsBasicSetting(): Observable<any> {
    return this.subject.asObservable();
  }

  constructor(private appInitService: AppInitService, private httpClient: HttpClient, private toastService: ToastService, private router: Router, private store: Store<State>) {
    this.appInitService.getAppConfiguration$().subscribe({
      next: (config) => this._onReceiveAppConfig(config)
    })
  }


  private _onReceiveAppConfig(appConfig: AppConfigurations) {
    this.appConfig = appConfig;
    this.baseApiUrl = this.appConfig.adminApi.baseApiUrl;
    this.lookUpsController = this.appConfig.adminApi.lookupsController;
    this.servicesUri = `${this.baseApiUrl}${this.appConfig.adminApi.serviceController}`;
  }

    getPreferredLanguage() {
    this.store.select(getLoggedInUserInfo).subscribe((user) => {
      if (user !== undefined && user !== null && user['preferredLanguage']) {
        this.preferredLanguageId = user['preferredLanguage'];
      }
    }
    );
  }

  private get languageParam(): HttpParams {
      return new HttpParams().set('preferredLanguageId', this.preferredLanguageId.toString());
  }

  public getProductServices(gridParams: CheckListGridParam): Observable<IServiceGrid<ProductServicesResponseModel>> {
    this.getPreferredLanguage();
    let queryparams = this.getCheckListQueryParams(gridParams);
    return this.httpClient.get<IServiceGrid<ProductServicesResponseModel>>(`${this.baseApiUrl}${this.lookUpsController}/${this.endpoint}/${queryparams}`,
      {params: this.languageParam});

    // if ((productServicesRequest.productCategoryId === 0 || productServicesRequest.productCategoryId === undefined)) {

    //   if (productServicesRequest.searchText) {
    //     return result.pipe(map(items => items.filter(item => (item.serviceDisplayName.toLowerCase().indexOf(productServicesRequest.searchText.toLowerCase()) > -1) || (item.productCategoryDisplayName.toLowerCase().indexOf(productServicesRequest.searchText.toLowerCase()) > -1))));
    //   }

    //   return result;
    // }

    // if ((productServicesRequest.productCategoryId > 0 || productServicesRequest.productCategoryId !== undefined)) {

    //   if ((productServicesRequest.searchText)) {
    //     return result.pipe(map(items => items.filter(item => ((item.serviceDisplayName.toLowerCase().indexOf(productServicesRequest.searchText.toLowerCase()) > -1) || (item.productCategoryDisplayName.toLowerCase().indexOf(productServicesRequest.searchText.toLowerCase()) > -1)) && (item.productCategoryId === productServicesRequest.productCategoryId))));
    //   }

    //   return result.pipe(map(psr => psr.filter(val => val.productCategoryId === productServicesRequest.productCategoryId)));
    // }
  }

  // methods to get data from server

  private getCheckListQueryParams(params: CheckListGridParam): string {
    const skip = (params.pageInfo.Page - 1) * params.pageInfo.PageSize;
    return `?ProductCategoryId=${params.productCategoryId}&SearchText=${params.searchText}&PageInfo.Page=${params.pageInfo.Page}&PageInfo.PageSize=${params.pageInfo.PageSize}
  &Pageinfo.Skip=${skip}&SortInfo.SortColumn=${params.sortInfo.SortColumn}&SortInfo.SortDirection=${params.sortInfo.sortDirection}`;
  }
  private getQueryParams(params: ServiceGridParams): string {
    const skip = (params.pageInfo.Page - 1) * params.pageInfo.PageSize;
    return `?productCategory=${params.productCategory}&type=${params.type}&status=${params.status}&language=${params.language}&optIn=${params.optIn}&SearchText=${params.searchText}&PageInfo.Page=${params.pageInfo.Page}&PageInfo.PageSize=${params.pageInfo.PageSize}
  &Pageinfo.Skip=${skip}&SortInfo.SortColumn=${params.sortInfo.SortColumn}&SortInfo.SortDirection=${params.sortInfo.sortDirection}&locationId=${params.locationId}&fromLocationModule=${params.fromLocationModule}&manualSort=${params.manualSort}&locationTypeId=${params.locationTypeId}`;
  }

  getLocationsForService(gridParams: LocationsServiceGridParams) {
    let queryParams = new HttpParams();
    queryParams = queryParams
      .set("loggedInLocationId", gridParams.loggedInLocationId.toString())
      .set("type", gridParams.type)
      .set("serviceId", gridParams.serviceId.toString())
      .set("optInStatus", gridParams.optInStatus.toString())
      .set("locationIds", gridParams.locationIds.toString())
      .set("enableDetails", gridParams.enableDetails.toString())
      .set("pageInfo.page", gridParams.pageInfo.Page.toString())
      .set("pageInfo.pageSize", gridParams.pageInfo.PageSize.toString())
      .set("sortInfo.sortColumn", gridParams.sortInfo.SortColumn == null ? '' : gridParams.sortInfo.SortColumn)
      .set("sortInfo.sortDirection", gridParams.sortInfo.sortDirection == null ? '' : gridParams.sortInfo.sortDirection.toString())
      .set("manulaSort", gridParams.manulaSort.toString());

    return this.httpClient.get<IServiceGrid<ILocationsServiceGridData>>(`${this.servicesUri}/${gridParams.serviceId}/locations`, { params: queryParams });
  }

  getEmployeeSettingsGrid(gridParams: ServiceEmployeeSettingsParam) {
    let queryParams = new HttpParams();
    queryParams = queryParams.set("serviceId", gridParams.serviceId.toString())
      .set("loggedInLocationId", gridParams.loggedInLocationId.toString())
      .set("locationIds", gridParams.locationIds.toString())
      .set("optInStatus", gridParams.optInStatus.toString())
      .set("pageInfo.page", gridParams.pageInfo.Page.toString())
      .set("pageInfo.pageSize", gridParams.pageInfo.PageSize.toString())
      .set("sortInfo.sortColumn", gridParams.sortInfo.SortColumn == null ? '' : gridParams.sortInfo.SortColumn)
      .set("sortInfo.sortDirection", gridParams.sortInfo.sortDirection == null ? '' : gridParams.sortInfo.sortDirection.toString())
      .set("manulaSort", gridParams.manulaSort.toString())
      .set("userType", gridParams.userType.toString());
    return this.httpClient.get<IUserServiceDataGrid>(`${this.servicesUri}/${gridParams.serviceId}/users`, { params: queryParams });
  }

  getAppointmentSettingsGrid(gridParams: ServiceAppointmentSettingsParam) {
    let queryParams = new HttpParams();
    queryParams = queryParams.set("locationIds", gridParams.locationIds == null ? '' : gridParams.locationIds.join(","))
      .set("serviceId", gridParams.serviceId.toString())
      .set("loggedInLocationId", gridParams.loggedInLocationId.toString())
      .set("pageInfo.page", gridParams.PageInfo.Page.toString())
      .set("pageInfo.pageSize", gridParams.PageInfo.PageSize.toString())
      .set("sortInfo.sortColumn", gridParams.sortInfo.SortColumn == null ? '' : gridParams.sortInfo.SortColumn)
      .set("sortInfo.sortDirection", gridParams.sortInfo.sortDirection == null ? '' : gridParams.sortInfo.sortDirection.toString())
      .set("manulaSort", gridParams.manulaSort.toString());


    return this.httpClient.get<IServiceGrid<IServiceAppointmentSettingGridData>>(`${this.servicesUri}/${gridParams.serviceId}/appointmentSettings`, { params: queryParams });

  }

  getAppointmentSettings(locationServiceId: number, serviceId: number) {
    let queryParams = new HttpParams();
    queryParams = queryParams.set("Id", locationServiceId.toString())
      .set("serviceId", serviceId.toString());
    return this.httpClient.get<ServiceAppointmentSetting>(`${this.servicesUri}/${serviceId}/appointmentSettings/${locationServiceId}`);
  }

  getlobbySettings(gridParams: ServiceLobbyGridParam) {
    let queryParams = new HttpParams();
    queryParams = queryParams.set("loggedInLocationId", gridParams.loggedInLocationId.toString())
      .set("selectedLocationIds", gridParams.selectedLocationIds == null ? '' : gridParams.selectedLocationIds.join(","))
      .set("serviceId", gridParams.serviceId.toString())
      .set("pageInfo.page", gridParams.pageInfo.Page.toString())
      .set("pageInfo.pageSize", gridParams.pageInfo.PageSize.toString())
      .set("sortInfo.sortColumn", gridParams.sortInfo.SortColumn == null ? '' : gridParams.sortInfo.SortColumn)
      .set("sortInfo.sortDirection", gridParams.sortInfo.sortDirection == null ? '' : gridParams.sortInfo.sortDirection.toString())
      .set("manulaSort", gridParams.manulaSort.toString());
    return this.httpClient.get<IServiceGrid<IServiceLobbySettingsGridData>>(`${this.servicesUri}/${gridParams.serviceId}/lobbySettings`, { params: queryParams });
  }

  getLobbySetting(locationServiceId: number, serviceId: number) {
    return this.httpClient.get<ServiceLobbySetting>(`${this.servicesUri}/${serviceId}/lobbySettings/${locationServiceId}`);
  }
  public getSerivcesGridData(gridParams: ServiceGridParams): Observable<IServicesGrid> {
    let queryparams = this.getQueryParams(gridParams);
    return this.httpClient.get<IServicesGrid>(`${this.servicesUri}${queryparams}`);
  }

  public saveService(service: ServiceBasicSetting): Observable<number> {
    return this.httpClient.post(this.servicesUri, service).pipe(map((response: any) => {
      return response.id;
    }))
  }

  public updateBasicSetting(service: ServiceBasicSetting): Observable<ServiceBasicSetting> {
    return this.httpClient.put(`${this.servicesUri}/basicSettings/${service.Id}`, service).pipe(
      map(() => service))
  }

  public updateAppointmentSetting(serviceAppointment: ServiceAppointmentSetting): Observable<ServiceAppointmentSetting> {
    return this.httpClient.put(`${this.servicesUri}/appointmentSettings/${serviceAppointment.id}`, serviceAppointment).pipe(
      map(() => serviceAppointment)
    )
  }

  public updateLobbySetting(serviceLobby: ServiceLobbySetting): Observable<ServiceLobbySetting> {
    return this.httpClient.put(`${this.servicesUri}/lobbySettings/${serviceLobby.id}`, serviceLobby).pipe(
      map(() => serviceLobby)
    )
  }

  public updateOptInOutSettings(optInOutSetting: ServiceOptInSetting) {
    return this.httpClient.patch(`${this.servicesUri}/${optInOutSetting.serviceId}/optInOutSettings`, optInOutSetting).pipe(
      map(() => optInOutSetting)
    );
  }

  public updateEmployeeSettings(employeeSettings: ServiceEmployeeSetting) {
    return this.httpClient.patch(`${this.servicesUri}/${employeeSettings.serviceId}/employeeSettings`, employeeSettings).pipe(
      map(() => employeeSettings)
    );
  }

  public validateServiceName(serviceId: number, languageId: number, fieldToValidate: string, value: string): Observable<boolean> {
    let queryParams = new HttpParams();
    queryParams = queryParams.
      set("id", serviceId.toString())
      .set("languageId", languageId.toString())
      .set("fieldToValidate", fieldToValidate)
      .set("fieldValue", value);
    return this.httpClient.get<boolean>(`${this.servicesUri}/validate`,
      { params: queryParams });
  }



  public updateServiceSortOrder(sortOrderModel: ServiceSortOrderModel): Observable<{}> {
    return this.httpClient.put(`${this.servicesUri}/sortOrder`, sortOrderModel);
  }

  public activateService(serviceId: number): Observable<{}> {
    return this.httpClient.patch(`${this.servicesUri}/${serviceId}/activate`, serviceId);
  }

  public deactivateService(serviceId: number): Observable<{}> {
    return this.httpClient.patch(`${this.servicesUri}/${serviceId}/deactivate`, serviceId);
  }
  public deleteService(serviceId: number, reassignedServiceId: number): Observable<{}> {
    return this.httpClient.delete(`${this.servicesUri}/Service/${serviceId}/${reassignedServiceId}`);
  }
  public getServiceData(id: number): Observable<Service> {
    let queryParams = new HttpParams();
    return this.httpClient.get<Service>(`${this.servicesUri}/${id}`);
  }



  public getServiceForEdit(): Service {
    return this.serviceDataforEdit;
  }

  public setServiceDataForEdit(serviceData: Service) {
    this.serviceDataforEdit = serviceData;
    this.serviceSubject.next(serviceData);
  }

  public setPageMode(mode: string) {
    this.pageMode = mode;
  }

  public setButtonType(mode: string) {
    this.buttonType = mode;
  }

  public getPageMode() {
    return this.pageMode;
  }

  public getLocalizedTextList(): LocalizedText[] {
    if (this.serviceDataforEdit) {
      return this.serviceDataforEdit.localizedTextList;
    }
    else {
      return new Array<LocalizedText>();
    }
  }

  getLocalizedText(locationServiceId: number, languageId: number, localizedFieldId: number, text: string): LocalizedText {
    let localizedText = new LocalizedText();
    localizedText.languageId = languageId;
    localizedText.localizedFieldId = localizedFieldId;
    localizedText.text = text;
    return localizedText;
  }

  public setLanguages(langues: Language[]) {
    if (langues) {
      const filterLanguages = langues.filter(s => s.languageId === 1 || s.languageId === 3);
      this.languagesSubject.next(filterLanguages);
    }
  }

  showErrorToast(errorMessage: string) {
    this.toastService.showError(errorMessage);
  }

  showSuccessToast(successMessage: string) {
    this.toastService.showSuccess(successMessage);
  }

  backToServiceGrid() {
    this.router.navigate(['admin/product-and-service']);
  }

  public setCategoryData(categories: ProductCategoryCodesAndNames[]) {
    if (categories) {
      const mappedCategories = categories.map(data => {
        return {
          categoryId: data.id,
          categoryName: data.categoryName
        }
      });
      const sortedCategories = this.sortCategoryByName(mappedCategories);
      this.categoriesSubject.next(sortedCategories);
    }
  }

  private sortCategoryByName(categories: any[]) {
    return categories.sort(function (cat1, cat2): number {
      if (cat1.categoryName < cat2.categoryName) { return -1; }
      if (cat1.categoryName > cat2.categoryName) { return 1; }
      return 0;
    })
  }


  setMeetingPreferences(preferences: string) {
    if (preferences) {
      this.meetingPreferencesSubject.next(preferences);
    }
  }

  getServiceTypes() {
    return this.serviceTypes;
  }

  setServiceTypes(serviceTypes: SerivceType[]) {
    if (serviceTypes) {
      this.serviceTypeSubject.next(serviceTypes);
    }
  }


  setLocationHierachy(locationsHierachy: SignedUserLocations) {
    if (locationsHierachy) {
      this.locationHierachySubject.next(locationsHierachy);
    }
  }

  getAllSortedServices(locationId: number, isFromLocationModule: boolean): Observable<ServiceSortOrder[]> {
    this.getPreferredLanguage();
    return this.httpClient.get<ServiceSortOrder[]>(`${this.servicesUri}/${locationId}/${isFromLocationModule}/services`,
      {params: this.languageParam});

  }

  public setParentLocation(parentLocations: number[]) {
    this.parentLocationIds = parentLocations;
  }

  public setAppointmentSettingData(appointmentSettingData: any) {
    this.appointmentSettingData = appointmentSettingData;
  }
  public setLobbySettingData(lobbySettingData: IServiceLobbySettingsGridData) {
    this.lobbuSettingData = lobbySettingData;
  }

  public updateBulkLobbySetting(serviceId: number, serviceAppointment: ServiceLobbyAppSetting): Observable<any> {
    return this.httpClient.put(`${this.servicesUri}/bulkLobbySettings/${serviceId}`, serviceAppointment).pipe(
      map(() => serviceAppointment)
    )
  }
  public updateBulkAppointmentSetting(serviceId: number, serviceLobby: ServiceLobbyAppSetting): Observable<any> {
    return this.httpClient.put(`${this.servicesUri}/bulkAppointmentSettings/${serviceId}`, serviceLobby).pipe(
      map(() => serviceLobby)
    )
  }

}

